module.exports = __webpack_public_path__ + "static/USIC-60c30751abeaf48f5be3e58b26257520.svg";